import { ReactNode } from 'react';
import { BookmarkIcon, CalendarIcon, PlayIcon } from '@heroicons/react/24/outline';

export function ProposalCard({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <div className={`bg-white border border-gray-200 rounded-lg shadow-sm ${className}`}>{children}</div>;
}

export function SaveMark({ align = 'center' }: { align?: 'center' | 'end' }) {
  return (
    <button
      type="button"
      aria-label="Add to My ORBCoN"
      className={`min-h-[44px] min-w-[44px] inline-flex flex-shrink-0 rounded-md text-accent ${align === 'end' ? 'items-start justify-end' : 'items-center justify-center'}`}
    >
      <BookmarkIcon className="h-5 w-5" aria-hidden />
    </button>
  );
}

export function CalendarCorner() {
  return (
    <button
      type="button"
      aria-label="Add to Calendar"
      title="Add to Calendar"
      className="min-h-[44px] min-w-[44px] inline-flex flex-shrink-0 items-start justify-end rounded-md text-gray-700"
    >
      <CalendarIcon className="h-5 w-5" aria-hidden />
    </button>
  );
}

export function CalendarMark({ className = '' }: { className?: string }) {
  return (
    <button
      type="button"
      className={`inline-flex items-center justify-center gap-2 min-h-[44px] px-3 rounded-md border border-gray-300 bg-gray-50 text-sm font-medium text-gray-700 ${className}`}
    >
      <CalendarIcon className="h-4 w-4" aria-hidden />
      Add to Calendar
    </button>
  );
}

export function WatchMark({ className = '' }: { className?: string }) {
  return (
    <button type="button" className={`inline-flex items-center justify-center gap-1 min-h-[44px] px-3 text-sm font-medium text-primary ${className}`}>
      <PlayIcon className="h-4 w-4" aria-hidden />
      Watch recording
    </button>
  );
}

export function ViewCourseMark() {
  return (
    <span className="inline-flex items-center min-h-[44px] text-sm font-medium text-primary flex-shrink-0">View course</span>
  );
}
